import React from 'react';
import { Link } from 'react-router-dom';

const SECTIONS = [
  {
    title: '1. Acceptance of terms',
    body: `By creating an account, downloading, or playing CascadeJoy on the web or on Android/iOS, you agree to these Terms & Conditions. If you do not agree, please do not use the app or this website.`,
  },
  {
    title: '2. Accounts',
    body: `You may play as a guest on-device, or create an account (email/password or Google) to sync your progress, levels, and reward balances across devices. You are responsible for keeping your login credentials secure, and for all activity that happens under your account.`,
  },
  {
    title: '3. In-game currency and rewards',
    body: `Gold Coins, Quantum Shards, Galaxy Keys, Research Points, Time Pods, and cosmetic items ("virtual items") have no real-world monetary value, cannot be exchanged for cash, and are not transferable between accounts. We may adjust reward amounts, level rewards, or how virtual items are earned at any time to keep the game balanced and fair.`,
  },
  {
    title: '4. Acceptable use',
    body: `You agree not to: cheat, exploit bugs, or use unauthorized third-party tools to modify game behavior or inflate scores/rewards; attempt to access another player's account; reverse-engineer, decompile, or resell any part of the app; or use the app or website for any unlawful purpose.`,
  },
  {
    title: '5. Purchases',
    body: `If optional purchases (such as ad removal or cosmetic packs) are available, prices are shown before you buy and are processed through the applicable app store (Google Play or the Apple App Store). Refunds are handled according to that store's own policies — we do not process payments directly.`,
  },
  {
    title: '6. Advertising',
    body: `The app may show optional rewarded ads (for example, to earn an extra hint) provided by third-party ad networks. Ads are never required to complete a level.`,
  },
  {
    title: '7. Suspension and termination',
    body: `We may suspend or terminate accounts that violate these terms, including cheating, abuse, or fraudulent activity. You may stop using the app or request account deletion at any time — see our Support page.`,
  },
  {
    title: '8. Disclaimer and liability',
    body: `CascadeJoy is provided "as is" without warranties of any kind. We are not liable for any indirect or incidental damages arising from your use of the app or website, to the fullest extent permitted by law.`,
  },
  {
    title: '9. Changes to these terms',
    body: `We may update these Terms & Conditions from time to time. Continuing to use CascadeJoy after changes are posted means you accept the updated terms.`,
  },
  {
    title: '10. Contact',
    body: `Questions about these terms? Reach out via the Support page.`,
  },
];

export default function TermsAndConditions() {
  return (
    <div className="min-h-screen" style={{ background: 'var(--brand-bg)' }}>
      <div className="mx-auto max-w-3xl px-4 py-14 sm:px-6 lg:px-8">
        <span className="pill">Legal</span>
        <h1 className="page-title section-gap">Terms &amp; Conditions</h1>
        <p className="page-subtitle">Last updated: August 8, 2026 · Applies to CascadeJoy on web, Android, and iOS.</p>

        <div className="mt-8 space-y-6">
          {SECTIONS.map((s) => (
            <section key={s.title} className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm sm:p-6">
              <h2 className="text-base font-black text-slate-900">{s.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{s.body}</p>
            </section>
          ))}
        </div>

        <Link to="/" className="mt-8 inline-block text-sm font-bold text-[var(--brand-primary)] hover:underline">
          ← Back to home
        </Link>
      </div>
    </div>
  );
}
